export default __webpack_public_path__ + "static/media/servercard.8570c734.gif";